import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    searchOpen: false,
    navOpen: false,
    drawerOpen: false,
    searchQuery: "",
    alertActive: false,
  },
  mutations: {
    setQuery(state) {
      if (Object.keys(router.currentRoute.query).length !== 0) {
        if (router.currentRoute.query.s) {
          state.searchQuery = router.currentRoute.query.s;
        } else {
          state.searchQuery = "";
        }
      }
    },
  },
  actions: {
    setQuery({ commit }) {
      commit("setQuery");
    },
  },
});
